import { useLoggedUser } from "@/shared/store/auth";
import React, { useEffect } from "react";
import useCookieSessionManager from "./useCookieSessionManager";
import { MAXCOREOldAdapter } from "@/shared/services/qrtk/auth/adapters/maxcore-old-user.adapter";
import UserAuthenticateAdapter from "@/shared/services/qrtk/auth/adapters/user-authenticate.adapter";
import { I_CurrentUserResponseData } from "@/shared/services/qrtk/auth/model/responses/current-user";
import { useLazyGetCurrentUserQuery } from "@/src-refactor/modules/store/qrtk/services/users/users.qrtk";

const useCheckUserLogged = () => {
  const [GET_CURRENT_USER_M] = useLazyGetCurrentUserQuery();
  const [userValidatingStatus, setLoader] = React.useState(true);
  const { userLogged, setUserData } = useLoggedUser();
  const {
    setSessionDataUserFormMaxcorev1,
    removeSessionFromCookie,
    token: { token, maxCoreTokenV1 }
  } = useCookieSessionManager();

  const loadUserSession = (res: I_CurrentUserResponseData) => {
    const oldMaxcore = MAXCOREOldAdapter(res, maxCoreTokenV1 ?? "");
    setSessionDataUserFormMaxcorev1(oldMaxcore);

    const newMaxcore = UserAuthenticateAdapter({
      maxCoreTokenV1: maxCoreTokenV1,
      token: token ?? "",
      userData: res
    });

    setUserData(newMaxcore);

    return new Promise(resolve => {
      resolve(newMaxcore);
    });
  };

  const getDataUser = async () => {
    setLoader(true);
    const dataUser = await GET_CURRENT_USER_M(null)
      .unwrap()
      .then()
      .catch(() => {
        removeSessionFromCookie();
        setLoader(false);
      });

    if (dataUser) {
      await loadUserSession(dataUser);
      setLoader(false);
    } else {
      removeSessionFromCookie();
      setLoader(false);
    }
  };

  useEffect(() => {
    if (token) {
      setUserData({
        token: token,
        maxCoreTokenV1: maxCoreTokenV1
      });

      getDataUser();
    } else {
      setLoader(false);
    }
  }, [token]);

  return { userLogged, userValidatingStatus };
};

export default useCheckUserLogged;
